import { handleActions } from 'redux-actions'
import { fromJS } from 'immutable'
import * as Actions from 'actions/home'
import * as AppActions from 'actions/app'

export const initialState = fromJS({
  selectedTab: 'monitoring',
  modulePreviewData: {},
  featureModalDialogOpen: false
})

export default handleActions({
  [Actions.setSelectedTab]: (state, { payload }) => state.set('selectedTab', fromJS(payload)),
  [Actions.openFeatureModalDialog]: (state, { payload }) => state.set('modulePreviewData', fromJS(payload))
    .set('featureModalDialogOpen', true),
  [Actions.closeFeatureModalDialog]: state => state.set('featureModalDialogOpen', false),
  [AppActions.resetState]: () => initialState
}, initialState)
